<!--<div class="card flex justify-content-center gap-2">
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<button (click)="Confirm()" >Confirm</button>
| date:'yyyy-MM-dd'
</div>-->
<!--<p-dialog [(visible)]="ConfirmationPrice" header="Price Details" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" closable="true">

<div style=" border-radius: 5px; padding: 8px; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
  <span style="color:black;font-weight:bold;font-size:18px;width:100%;display:flex;justify-content:center;align-items:center;padding-bottom:5px;padding-top:5px">
    Do You Want to Proceed the Booking with this Fare?
  </span>
  <br />
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">Passenger Type</th>
        <th scope="col">Base Fare</th>
        <th scope="col">Taxes</th>
        <th scope="col">Service Fee</th>
        <th scope="col">Discount</th>
        <th scope="col">Total Fare</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let obj of updatePassengerObj.passengerFares;let i= index">
        <th scope="row" *ngIf="obj.passengerType == 1">ADT</th>
        <th scope="row" *ngIf="obj.passengerType == 2">CHD</th>
        <th scope="row" *ngIf="obj.passengerType == 3">INF</th>
        <td>{{obj.agencyBaseFareAmount}}</td>
        <td>{{obj.agencyTaxAmount}}</td>
        <td>{{obj.agencyServiceFee}}</td>
        <td>{{obj.agencyDiscount}}</td>
        <td>{{obj.agencyTotalPrice}}</td>
      </tr>

    </tbody>
  </table>
  <br />
  <div style="display:flex;justify-content:center;align-items:center;width:100%">
    <div style="width:25%;display:flex;justify-content:space-between">
      <button style="border-radius:4px;padding:5px 8px;background-color:#24a040;color:white" (click)="ConfirmPriceofPassengerFZ()">YES</button>
      <button style="border-radius:4px;padding:5px 8px;background-color:#cf3535;color:white" (click)="CancelpriceFZ()">NO</button>
    </div>


  </div>
</div>
</p-dialog>-->
@if (modifyBooking) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top:0px">
    <div class="loaderforPassenger_forBooking">
      <span class="message">Modify Booking In Process</span>
      <span class="loadspan"></span>
    </div>
  </div>
}

<div class="container">
  <div class="main-items">
    <div class="cardsmain" >
      <div style="background-color: #fcf4ed; padding: 10px; border-radius: 5px; justify-content: center; align-items: center; display: flex;  ">
        <span class="PassegerHeading">Modify Passenger</span>
      </div>

      <div class="Modify-main" >

        <!--<section class="sec-add">
        <div class="add-desc">Add Passenger</div>
        <div class="psngr-quantity">
          <div>
            <div class="add-subdesc">Adult</div>
            <button class="minus" name="RemoveAdult" value="AdultQuantity" (click)="RemovePassenger('Adult')">&#8722;</button>
            <input type="number" style="width:100px" [(ngModel)]="AdultQuantity" class="number-disap i-style" />
            <button class="plus" name="AddAdult" value="AdultQuantity" [disabled]="AdultDisable" (click)="AddPassenger('Adult')">&#43;</button>
          </div>
          <div>
            <div class="add-subdesc">Child</div>
            <button class="minus" name="RemoveChild" value="ChildQuantity" (click)="RemovePassenger('Child')">&#8722;</button>
            <input type="number" style="width:100px" [(ngModel)]="ChildQuantity" class="number-disap i-style" />
            <button class="plus" name="AddChild" value="ChildQuantity" [disabled]="ChildDisable" (click)="AddPassenger('Child')">&#43;</button>
          </div>
          <div>
            <div class="add-subdesc">Infant</div>
            <button class="minus" name="RemoveInfant" value="InfantQuantity" (click)="RemovePassenger('Infant')">&#8722;</button>
            <input type="number" style="width:100px" [(ngModel)]="InfantQuantity" class="number-disap i-style" />
            <button class="plus" name="AddInfant" value="InfantQuantity" (click)="AddPassenger('Infant')">&#43;</button>
          </div>

          <div style="margin-top:10px">
            <button class="add-btn" (click)="TakePassengersDetails()">Add</button>
          </div>
        </div>
      </section>-->
      @if (this.bookingInfo.bookingPassengerInfoProperties.length > 1) {
        <section class="sec-remove">
          <div class="add-desc">Remove Passenger</div>
          <div class="remo-psngr">
            <p class="remo-desc">IF you want to remove passengers from booking.Load Passenger Data to be removed</p>
            <button class="add-btn" (click)="RemovePassengerPop()">Load</button>
          </div>
        </section>
      }
      <section class="sec-remove">
        <div class="add-desc">Add Anxillaries</div>
        <div class="remo-psngr">
          <p class="add-anxi-desc">IF you want to Add Anxillaries in your current booking.</p>
          <button class="add-btn" (click)="AddAnxillariesINTOBooking()">Load</button>
        </div>
      </section>
      <section class="sec-remove">
        <div class="add-desc">Remove Anxillaries</div>
        <div class="remo-psngr">
          <p class="remo-anxi-desc">IF you want to remove Anxillaries from your booking.</p>
          <button class="add-btn" (click)="RemoveAnxillariesFromBooking()">Load</button>
        </div>
      </section>
      <section class="sec-remove">
        <div class="add-desc">Add / Remove Seats</div>
        <div class="remo-psngr">
          <p class="seat-anxi-desc">IF you want to Add / Remove seats from your booking.</p>
          <div class="seats-btn">
            <button class="seat-btn" (click)="GetSeatsForBooking()">ADD</button>
            <button class="seat-btn" (click)="RemoveSeatsFromBooking()">Remove</button>
          </div>
        </div>
      </section>

    </div>

    <p-dialog [(visible)]="RemovePass" header="Remove Passenger" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" closable="true">
      <div class="">
        <table class="table table-hover">
          <thead class="void_tab_head">
            <tr>
              <th scope="col">Passenger Name</th>
              <th scope="col">Type</th>
              <th scope="col">E-Ticket #</th>
              <th scope="col">Selection</th>
            </tr>
          </thead>
          <tbody class="void_tab_body">
            @for (passenger of RemovePassengerInfo; track passenger; let y = $index) {
              <tr>
                <td style="font-weight:500">
                  {{passenger.firstName}} {{passenger.lastName}}
                  @if (passenger.passengerType==3 && passenger.associatedAdult !=null) {
                    <span style="font-size:9px !important;color:orangered">Associated: {{passenger.associatedAdult}}</span>
                  }
                </td>
                @if (passenger.passengerType == 1 ) {
                  <td>Adult</td>
                }
                @if (passenger.passengerType == 2 ) {
                  <td>Child</td>
                }
                @if (passenger.passengerType == 3) {
                  <td>Infant</td>
                }
                <td>{{passenger.ticketNo}}</td>
                <td>
                  <label class="switch selectField">
                    <input type="checkbox" name="isSelected{{y}}" [(ngModel)]="passenger.paxRemFrmBkng" [disabled]="checkvoid" (change)="Removecheckpassenger(y)" [checked]="passenger.paxRemFrmBkng" />
                    <span></span>
                  </label>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <div style="display:flex;width:100%;">
          <div style="width:50%;text-align:left;display:flex">
            <span style="margin-left:4px;color:red;font-weight:bold;font-size:13px" id="voidrequiredmsg"></span>
          </div>
          <div style="width: 50%; text-align: right; display: flex;justify-content:right">
            <button class="save_but" (click)="RmvPassengerFrmBooking()">Remove</button>
          </div>
        </div>


      </div>
    </p-dialog>

    @if ((bookingInfo.exchangebookingPassengerInfoProperties.length > 0) && (AddPax== true)) {
      <form class="noti col-sm-9 form-line-active tttt">
        <div class="form_title cross">Modify Passengers <span style="color:#008A00;font-size:11pt" (click)="removeModifyClose()"> &#x274c; </span></div>
        @for (obj of bookingInfo.exchangebookingPassengerInfoProperties; track obj; let i = $index) {
          <div class="forms_container_main infant_type">
            <div class="main_form">
              <div class="row py-2 m-0">
                <div class="col-md-4 py-2 px-1">
                  @if (obj.passengerType == 1) {
                    <div class="detail_title" id="ptype{{i}}">Adult:</div>
                  }
                  @if (obj.passengerType == 2) {
                    <div class="detail_title">Child:</div>
                  }
                  @if (obj.passengerType == 3) {
                    <div class="detail_title">Infant:</div>
                  }
                  @if (obj.passengerType == 1) {
                    <span class="detail_sub-title">12 years or Above</span>
                  }
                  @if (obj.passengerType == 2) {
                    <span class="detail_sub-title">Less than 12 years</span>
                  }
                  @if (obj.passengerType == 3) {
                    <span class="detail_sub-title">Less than 2 years</span>
                  }
                </div>
                <div class="col-md-4 py-2 px-1">
                  <div class="search newsearxhfocus">
                    <input class="main_text-boxs" #ctc [(ngModel)]="obj.mobile" name="searchctc{{i}}" (blur)="getSearchonfocusout(popupsearch,ctc.value,i)" type="text" id="mobilenumbervalidate{{i}}" placeholder="e.g.  +971234567890" />
                    <label for="" class="input_lab_search" id="labelmobile{{i}}">Search Mobile Number</label>
                    <button class="searchButton" id="buttonmobilesearch{{i}}" (click)="SearchCtcNo(popupsearch,ctc.value,i)" type="submit"><span><i class="fas fa-search searchfy"></i></span></button>
                  </div>
                  <span class="mobile-required" id="messagepass{{i}}"></span>
                  <!--end here-->
                </div>
                <div class="col-md-4">
                </div>
                <ng-template #popupsearch let-modal>
                  <div class="modal-header">
                    <span class="closepopup" (click)="modal.dismiss()">&times;</span>
                    <h2 class="textpopup">Passenger Profile Details</h2>
                  </div>
                  <div class="modal-body">
                    <div class="alert alert-danger hiddenclasspstype newpswarn" id="pstypealert" role="alert">
                      Please Select<strong id="warningPsType"></strong>
                    </div>
                    <div id="grids">
                      <dx-data-grid id="grid"
                        [dataSource]="searchprofileCred"
                        [showBorders]="true"
                        [showRowLines]="true">
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-paging [pageSize]="10"></dxo-paging>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <dxi-column [visible]="false" dataType="number" dataField="profile_Id" alignment="center"></dxi-column>
                        <dxi-column dataField="title" caption="Title" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="firstName" caption="First Name" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="lastName" caption="Last Name" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="paxGender" [visible]="false" caption="Gender" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="paxDOB" [visible]="false" caption="DOB" dataType="date" alignment="center"></dxi-column>
                        <dxi-column dataField="mobile_No" [visible]="false" caption="Mobile No" dataType="string" alignment="center"></dxi-column>
                        <!--<dxi-column dataField="phone_No" dataType="string" alignment="center"></dxi-column>-->
                        <!--<dxi-column dataField="passportValidFrom" caption="Passport Valid" dataType="date" alignment="center"></dxi-column>-->
                        <dxi-column dataField="passportValidTo" caption="Passport Expiry Date" dataType="date" alignment="center"></dxi-column>
                        <dxi-column dataField="passportNumber" caption="Passport No" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="passengerType" [visible]="false" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="passengerTypeName" caption="Passenger Type" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="paxNationality" [visible]="false" caption="Nationality" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="email_Id" [visible]="false" dataType="string" caption="Email" alignment="center"></dxi-column>
                        <dxi-column dataField="frequent_Flyer_No" [visible]="false" caption="Frequent Flyer No" dataType="string" alignment="center"></dxi-column>
                        <dxi-column dataField="countryOfIssuance" caption="Country of Issuance" dataType="string" alignment="center"></dxi-column>
                        <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
                        <div *dxTemplate="let data of 'actionCellTemplate'">
                          <a class="profilesearchbutton" style="margin-left:10px" (click)="Select_Profiledata(data.data)"><i class="fas fa-check-square"></i> Select</a>
                        </div>
                      </dx-data-grid>
                    </div>
                    <div class="modal-footer">
                    </div>
                  </div>
                </ng-template>
              </div>
              <div class="row m-0 py-2">
                <div class="col-sm-2 poisiton_Columns  px-1">
                  <select class="main_text-box title_box" [(ngModel)]="obj.title" id="titles{{i}}" (change)="genderSelectonGivenTitle(i)" name="title{{i}}">
                    @if (obj.passengerType == 1) {
                      <option>
                        Mr
                      </option>
                    }
                    @if (obj.passengerType == 1) {
                      <option>
                        Ms
                      </option>
                    }
                    @if (obj.passengerType == 1) {
                      <option>
                        Mrs
                      </option>
                    }
                    @if (obj.passengerType == 2 ||obj.passengerType == 3) {
                      <option>
                        Mstr
                      </option>
                    }
                    @if (obj.passengerType == 2 ||obj.passengerType == 3) {
                      <option>
                        Miss
                      </option>
                    }
                  </select>
                  <div>
                    <label for="" class="input_lab_first" id="titlelabel{{i}}">Title</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageTitleRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-4 poisiton_Columns  px-1">
                  <input class="main_text-box new_main_Text_Box " (blur)="toTitleCase(i,obj.firstName,$event)" [(ngModel)]="obj.firstName" id="firstname{{i}}" name="firstName{{i}}" type="text" />
                  <div>
                    <label for="" class="input_lab_first" id="firstlabel{{i}}">First Name</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageFirstnameRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-4 poisiton_Columns  px-1">
                  <input class="main_text-box" type="text" (blur)="toTitleCase(i,obj.lastName,$event)" [(ngModel)]="obj.lastName" id="lastname{{i}}" name="lastName{{i}}">
                  <div>
                    <label for="" class="input_lab_first" id="lastlabel{{i}}">Last Name</label>
                  </div>
                  <div>
                    <span class="first-required" id="messagelastnameRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-2  poisiton_Columns  px-1">
                  <select class="main_text-box title_box " [(ngModel)]="obj.paxGender" id="gender{{i}}" name="paxGender{{i}}">
                    <option id="male{{i}}">
                      Male
                    </option>
                    <option id="female{{i}}">
                      Female
                    </option>
                    <option>
                      Other
                    </option>
                  </select>
                  <div>
                    <label for="" class="input_lab_first" id="genderlabel{{i}}">Gender</label>
                  </div>
                  <div>
                    <span class="first-required" id="messagegenderRquired{{i}}"></span>
                  </div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-sm-2 pb-2 px-1">
                  <input class="main_text-box " type="text" [(ngModel)]="obj.passportNumber" id="passportnum{{i}}" name="passportNumber{{i}}">
                  <div>
                    <label for="" class="input_lab_first " id="ppnlabel{{i}}">Passport No</label>
                  </div>
                  <div>
                    <span class="first-required" id="messagePPNRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-4 pb-2 px-1">
                  <input class="main_text-box new_main_Text_Box" type="date" [(ngModel)]="obj.passportValidTo" id="pasportvalidto{{i}}" name="passportValidTo{{i}}">
                  <div>
                    <label for="" class="input_lab_first " id="pexplabel{{i}}">Passport Expiry</label>
                  </div>
                  <div>
                    <span class="first-required" id="messagePassExpRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-4 pb-2 px-1">
                  <ng-select class="country-issuance-Class   countryOfIssueclass" [items]="countryList"
                    id="countryborderClass{{i}}"
                    bindLabel="countryName" bindValue="code"
                    [searchable]="true"
                    (click)="CountryofIsuuance_Focus_Input(i)"
                    (blur)="Coi_Focus(i)"
                    placeholder="Select"
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="obj.countryOfIssuance">
                  </ng-select>
                  <div>
                    <label for="" class="input_lab_first countryOfIssueclass" id="countryLabel{{i}}">Country of Issuance</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageCoIRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-2 pb-2 px-1">
                  <input class="main_text-box" type="text" [(ngModel)]="obj.frequent_Flyer_No" id="Frequent_Flyer_No{{i}}" name="Frequent_Flyer_Nos{{i}}">
                  <div>
                    <label for="" class="input_lab_first">Frequent Flyer No</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageFFNRquired{{i}}"></span>
                  </div>
                </div>
              </div>
              <div class="row m-0 ">
                <div class="col-sm-4  px-1">
                  <input class="main_text-box" type="date" [(ngModel)]="obj.paxdob" name="paxDOB{{i}}" id="dob_input{{i}}">
                  <div>
                    <label for="" class="input_lab_first" id="doblabel{{i}}">Date of Birth</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageDobRquired{{i}}"></span>
                  </div>
                </div>
                @if (J9Anxi) {
                  <div class="col-sm-3">
                    <label for="" class="input_lab-expiry">Passport Issued on</label>
                    <input class="main_text-box" type="date" [(ngModel)]="obj.passportValidFrom" id="pasportdatefrom{{i}}" name="passportValidFrom{{i}}" (change)="issuanceValidation($event)">
                  </div>
                }
                <div class="col-sm-4  px-1">
                  <ng-select class="nationalityClass  "
                    id="nationcc{{i}}"
                    [items]="countryList"
                    placeholder="Select"
                    bindLabel="countryName" bindValue="code"
                    [searchable]="true"
                    (click)="Nation_Focus(i)"
                    (blur)="Coi_Focus(i)"
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="obj.paxNationality">
                  </ng-select>
                  <div>
                    <label for="" class="input_lab_first" id="nationLabel{{i}}">Nationality</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageNationRquired{{i}}"></span>
                  </div>
                </div>
                <div class="col-sm-4 px-1">
                  <input class="main_text-box" type="text" [(ngModel)]="obj.email" id="email{{i}}" name="email{{i}}" (blur)="emailverifyregex(obj.email,i)">
                  <div>
                    <label for="email" class="input_lab_first" id="emaillabel{{i}}">Email</label>
                  </div>
                  <div>
                    <span class="first-required" id="messageEmailRquired{{i}}"></span>
                  </div>
                </div>
              </div>
              @if (airsialpaskistan) {
                <div class="row m-0">
                  <div class="col-sm-4 pb-2 px-1">
                    <input class="main_text-box " type="text" (blur)="chnagepscnic(i)" [(ngModel)]="obj.cnic" id="cnicnum{{i}}" name="cnic{{i}}">
                    <div>
                      <label for="" class="input_lab_first " id="cniclabel{{i}}">CNIC No</label>
                    </div>
                    <div>
                      <span class="first-required" id="cnicnummsg{{i}}"></span>
                    </div>
                  </div>
                </div>
              }
              @if (obj.passengerType == 3) {
                <div class="row m-0">
                  <div class="col-sm-4 pb-2 px-1">
                    <ng-select class="nationalityClass  "
                      id="Personrspinfant{{i}}"
                      [items]="associatedadultNameList"
                      placeholder="Select"
                      bindLabel="adultName" bindValue="adultfirstName"
                      [searchable]="true"
                      (click)="AssociatedAdultsWithInfant(i)"
                      (blur)="focusoutassociatedadult(i)"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="obj.associatedAdult">
                    </ng-select>
                    <div>
                      <label for="" class="input_lab_first " id="Personrspinfantlabel{{i}}">Person responsible for the infant</label>
                    </div>
                    <div>
                      <span class="first-required" id="Personrspinfantmsg{{i}}"></span>
                    </div>
                  </div>
                </div>
              }
              <div style="display:none">
                <div class="que_travel">Travel Prefrences</div>
                <div class="que_line"></div>
                <!--<div class="personal-form">-->
                <div class="row" style="column-gap: 5px;">
                  <div class="col-sm-4 custon_inputs">
                    <label for="" class="input_lab ">Service Type</label>
                    <ng-select class="custom" [items]="serviceTypeList"
                      name="serviceType{{i}}"
                      bindLabel="serviceItemType" bindValue="serviceID"
                      [(ngModel)]="obj.serviceType"
                      (change)="changeServiceType(obj.serviceType)">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 custon_inputs description_list_class">
                    <label for="" class="input_lab ">Description</label>
                    <ng-select class="custom" id="description_list_class"
                      name="serviceSubType{{i}}"
                      [(ngModel)]="obj.serviceSubType">
                      @if (selectedValue == 1) {
                        <span>
                          @for (obj of countryCodeList; track obj) {
                            <ng-option value="{{obj}}">{{obj}}</ng-option>
                          }
                        </span>
                      }
                      @if (selectedValue == 2) {
                        <span>
                          @for (obj of mealListShow; track obj) {
                            <ng-option value="{{obj.mealID}}">{{obj.mealList}}</ng-option>
                          }
                        </span>
                      }
                      @if (selectedValue == 3) {
                        <span>
                          @for (obj of seatListShow; track obj) {
                            <ng-option value="{{obj.seatID}}">{{obj.seatList}}</ng-option>
                          }
                        </span>
                      }
                    </ng-select>
                  </div>
                  <div class="col-sm-3 custon_inputs ffno_class">
                    <label for="" class="input_lab ">FFNo/Sectors</label>
                    <input type="text" class="main_text-box ffno_class_input" [(ngModel)]="obj.sector" name="sector{{i}}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="btn-walls">
          <div class="apbutton-submit" (click)="SubmitAddPassenger()">Submit</div>
        </div>
      </form>
    }

    <!--//add Anxi -->
    <form class="noti col-sm-9 form-line-active hhh hid-anxi">
      <div class="anxi_title cross">Add Anxillaries <span style="color:#008A00;font-size:11pt" (click)="removeAddAnxiClose()"> &#x274c; </span></div>

      @for (obj of bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
        <div class="forms_container_main infant_type">
          <div class="main_form">
            <p class="">{{obj.firstName +" " +obj.lastName}}</p>
            @if ((airarbiaWithBaggage || fzAnxii) &&  obj.passengerType != 3) {
              <div class="Anci_mainClass">
                <div style="font-weight: bold; font-size: 18px; color: var(--first-color-second); padding: 5px; justify-content: center; display: flex; ">
                  Extras
                </div>
                @for (sector of obj.sectorInformationProperties; track sector; let z = $index) {
                  <div class="anci_section_main">
                    <div class="row" style=" margin-left: 21px;">
                      <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
                    </div>
                    <div class="anci_section_border">
                      <div class="anci_Section_columns">
                        <div class="anci_columns_head">
                          <div class="anci_columns_subhead">
                            <span class="anci_column_subject">Meal</span>
                            <span class="anci_column_name">{{sector.mealname}}</span>
                          </div>
                          <div style=" width: 10%">
                            <button class="anci_column_edit" (click)="mealopen(i,z,poperrornot)"><i class="fas fa-edit"></i></button>
                            <!--popup of meal-->
                            <div id="fZmeal{{i}}{{z}}" class="mealModel">
                              <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                                <div class="modal-dialog modal-lg" role="document" style="position: absolute; left: 250px;width:100%;">
                                  <div class="modal-content" style="width:100% !important">
                                    <div class="modal-header">
                                      <div class="seat_model_header">
                                        <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Meal Selection</span>
                                        <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="mealclose(i,z)" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="modal-body" style="padding: 0px !important;">
                                      <div style="width:100%;">
                                        <div style="width: 100%; padding: 6px;">
                                          <div class="mt-2 seat_info">
                                            <span class="seat_info_header" style="background-color: #39454B;">
                                              {{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:8px;margin-left:8px;color:white"></i> {{sector.toAirport}}
                                            </span>
                                            <div class="row">
                                              <div style="width:30%">
                                                <span class="seat_info_one_head ">
                                                  Passenger Name:
                                                </span>
                                              </div>
                                              <div style="width:70%">
                                                <span class="seat_info_one">
                                                  {{obj.title}} {{obj.firstName}} {{obj.lastName}}
                                                </span>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div style="width:30%">
                                                <span class="seat_info_one_head ">
                                                  Meal Name:
                                                </span>
                                              </div>
                                              <div style="width: 70%; ">
                                                <span class="seat_info_one">
                                                  {{sector.mealname}}
                                                </span>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div style="width:30%">
                                                <span class="seat_info_one_head ">
                                                  Meal Charges:
                                                </span>
                                              </div>
                                              <div style="width:70%">
                                                @if (bookingInfo.providerCode == 'G9' || bookingInfo.providerCode == '3L' || bookingInfo.providerCode == '9P') {
                                                  <span class="seat_info_one">
                                                    {{currency}} {{(sector.mealFee * currencyRate)| number: '1.1-2'}}
                                                  </span>
                                                }
                                                @if (bookingInfo.providerCode == 'FZ') {
                                                  <span class="seat_info_one">
                                                    {{currency}} {{(sector.mealFee)| number: '1.1-2'}}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        @if (G93LMeals) {
                                          <div style="width:100%;padding:6px;height:33rem;overflow:auto;">
                                            @for (mealsector of sector.mealListBysector; track mealsector; let m = $index) {
                                              <div class="meal_deatils_main">
                                                <div class="meal_Section">
                                                  <div class="meal_section_one_image">
                                                    <img style="height: 110px; width: 123px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="{{mealsector.mealImage}}" />
                                                  </div>
                                                  <div class="meal_Section_deatils">
                                                    <div class="meal_details_heading">
                                                      <div class="meal_details_heading_section_one">
                                                        <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.mealName}}</span>
                                                        <span style="font-size:12px;color:black;">
                                                          {{mealsector.mealDescription}}
                                                        </span>
                                                      </div>
                                                      <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                                        <span style="font-weight:bold;font-size:21px;">{{currency}} {{(mealsector.mealCharge* currencyRate)| number: '1.1-2'}}</span>
                                                      </div>
                                                    </div>
                                                    <div class="meal_deatils_button">
                                                      <button class="meal_button_add" id="mealselectbtn{{i}}{{z}}{{m}}" (click)="selectmeal(i,z,m)"><span id="mealselectid{{i}}{{z}}{{m}}">Select</span></button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }
                                        @if (FZMeals) {
                                          <div style="width:100%;padding:6px;height:33rem;overflow:auto;">
                                            @for (mealsector of fzMealArray; track mealsector; let m = $index) {
                                              <div class="meal_deatils_main">
                                                @for (mealsector of mealsector; track mealsector; let q = $index) {
                                                  <div>
                                                    <div class="meal_Section">
                                                      <div class="meal_section_one_image">
                                                        <img style="height: 110px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="../../assets/img/Wideroe.svg" />
                                                      </div>
                                                      <div class="meal_Section_deatils">
                                                        <div class="meal_details_heading">
                                                          <div class="meal_details_heading_section_one">
                                                            <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.description}}</span>
                                                            <span style="font-size:12px;color:black;">
                                                              {{mealsector.description}}
                                                            </span>
                                                          </div>
                                                          <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                                            <span style="font-weight: bold; font-size: 19px; color: orangered">{{currency}} {{(mealsector.amount * currencyRate)| number: '1.1-2'}}</span>
                                                          </div>
                                                        </div>
                                                        <div class="meal_deatils_button">
                                                          <button class="meal_button_add" id="mealselectbtn{{i}}{{z}}{{m}}{{q}}" (click)="fzMealSelect(i,z,m,q)"><span id="mealselectid{{i}}{{z}}{{m}}{{q}}">Select</span></button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end meal popup-->
                          </div>
                        </div>
                      </div>
                      <!--seat map of anci selectio -->
                      @if (bookingInfo.providerCode == 'G9' || bookingInfo.providerCode == '3L' || bookingInfo.providerCode == '9P') {
                        <div class="anci_Section_columns" style="margin-left:0.4%">
                          <div class="anci_columns_head">
                            <div class="anci_columns_subhead">
                              <span class="anci_column_subject">Seat</span>
                              <span class="anci_column_name">{{sector.seatNumber}}</span>
                            </div>
                            <div style=" width: 10%">
                              <button class="anci_column_edit" (click)="seatMapopen(i,z)" id="seatselectid{{i}}{{z}}"><i class="fas fa-edit"></i></button>
                              <div id="newmodelofseat{{i}}{{z}}" class="numofseatmodel">
                                <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                                  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                                    <div class="modal-content" style="width:100% !important">
                                      <div class="modal-header">
                                        <div class="seat_model_header">
                                          <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                          <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="seatMapclose(i,z)" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="modal-body" style="padding: 0px !important;">
                                        <div class="seat_model_body_one">
                                          <div class="seat_model_body_two">
                                            <span class="seat_info_header">
                                              Seatmap Legend
                                            </span>
                                            <div class="row mb-2">
                                              <div class="col-md-3">
                                                <button class="square-skew " disabled>
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                              <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                            </button>
                                          </div>
                                          <div class="col-md-9">
                                            <span>Seat Available</span>
                                          </div>

                                        </div>

                                        <div class="row mb-2">
                                          <div class="col-md-3">


                                            <button class="square-skew_not not_avail_Seat" disabled>
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                              <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                            </button>
                                          </div>
                                          <div class="col-md-9">
                                            <span>Seat Unavailable</span>
                                          </div>

                                        </div>

                                        <div class="row mb-2">
                                          <div class="col-md-3">


                                            <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                              <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                            </button>
                                          </div>
                                          <div class="col-md-9">
                                            <span>Seat Selected</span>
                                          </div>

                                        </div>
                                        <div class="row ">
                                          <div class="col-md-3">


                                            <button class="square-skew_not" style="background-color:orangered" disabled>
                                              <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                              <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                            </button>
                                          </div>
                                          <div class="col-md-9">
                                            <span>Seat Selected By Another Passenger</span>
                                          </div>

                                        </div>


                                      </div>
                                      <div class="mt-2 seat_info">
                                        <span class="seat_info_header">
                                          Seat Information
                                        </span>
                                        <span class="seat_info_header_sector">
                                          {{sector.fromAirport}} To {{sector.toAirport}}
                                        </span>
                                        <div class="row">
                                          <div class="col-md-4">
                                            <span class="seat_info_one_head ">
                                              Name:
                                            </span>
                                          </div>
                                          <div class="col-md-8" style="overflow:hidden;display:flex">
                                            <span class="seat_info_one">
                                              {{obj.firstName}}
                                            </span>
                                          </div>

                                        </div>
                                        <div class="row">
                                          <div class="col-md-4">
                                            <span class="seat_info_one_head ">
                                              Seat No:
                                            </span>
                                          </div>
                                          <div class="col-md-8">
                                            <span class="seat_info_one">
                                              {{sector.seatNumber}}
                                            </span>
                                          </div>

                                        </div>
                                        <div class="row">
                                          <div class="col-md-7">
                                            <span class="seat_info_one_head ">
                                              Seat Charges:
                                            </span>
                                          </div>
                                          <div class="col-md-5">
                                            <span class="seat_info_one">
                                              {{currency}} {{((sector.seatFee * currencyRate)| number: '1.1-2')}}
                                            </span>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                    <div class="seat_mdl_bdy_airone">
                                      <div class="seat_mdl_bdy_airtwo">
                                        <div>
                                          <img class="seat_wing_one" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                        </div>

                                        <div class="aircraft">
                                          <div class="aircraft-head">
                                            <!-- <div class="aircraft-head_inner"> -->
                                            <img style="width: 180px; padding-top: 32px;"
                                                 src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                                <!-- </div> -->
                                              </div>
                                              <div class="aircraft-body-exit-top">
                                                <div class="aircraft-body-exit-left-top">
                                                </div>
                                                <div class="aircraft-body-exit-top-center">
                                                </div>
                                                <div class="aircraft-body-exit-right-top">
                                                </div>
                                              </div>
                                              <div class="aircraft-body-exit">
                                                <div class="aircraft-body-exit-left">
                                                  <div class="aircraft-inner-rowclass">
                                                    <span>A</span>
                                                    <span>B</span>
                                                    <span>C</span>
                                                  </div>
                                                </div>
                                                <div class="aircraft-body-exit-right">
                                                  <div class="aircraft-inner-rowclass">
                                                    <span>D</span>
                                                    <span>E</span>
                                                    <span>F</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="aircraft-body-exit-top">
                                                <div class="aircraft-body-exit-left-top">
                                                </div>
                                                <div class="aircraft-body-exit-top-center">
                                                </div>
                                                <div class="aircraft-body-exit-right-top">
                                                </div>
                                              </div>
                                              <div class="aircraft-body-rowClass">
                                                <div class="aircraft-row-innner-body">
                                                  <div class="aircraft_inner_divone">
                                                    @for (rows of sector.seatListBysector; track rows; let k = $index) {
                                                      <div class="aircraft_inner_divtwo">
                                                        @for (seatobj of rows.seats; track seatobj; let q = $index) {
                                                          <div>
                                                            @if (seatobj.seatStatus == 'VAC' ) {
                                                              <button class="square-skew hover-text" (click)="seatselectedsector(i,z,k,q)" id="link3button{{i}}{{z}}{{k}}{{q}}">
                                                                <span class="tooltip-text" id="top{{k}}{{q}}">Seat Charge:{{currency}} {{(seatobj.seatCharge * currencyRate)| number: '1.1-2'}}</span>
                                                      <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                    </button>
}

                                                    @if (seatobj.seatStatus == 'RES' || seatobj.seatStatus == 'INA' ) {
<button class="square-skew_not not_avail_Seat" disabled id="link3{{k}}{{q}}">
                                                      <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                      <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                                    </button>
}
                                                    @if (seatobj.seatStatus == 'RSP' ) {
<button class="square-skew_not" style="background-color:orangered;cursor:not-allowed" disabled id="link3{{k}}{{q}}">
                                                      <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                      <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                                    </button>
}
                                                    @if ((q==2)) {
<button id="link3{{k}}{{q}}" class="aircraft_inner_res">
                                                      {{rows.rowNumber}}
                                                    </button>
}

                                                  </div>
}


                                                </div>
}



                                              </div>

                                            </div>
                                          </div>

                                          <!-- <div class="aircraft-bottom-wing">
                                            <div class="exists">
                                              <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                              <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                            </div>
                                          </div> -->
                                        </div>
                                        <div>
                                          <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>





                          </div>

                        </div>

                      </div>
                    </div>
}
                    <div class="anci_Section_columns" style="margin-left:0.4%">
                      <div class="anci_columns_head">
                        <div class="anci_columns_subhead">
                          <span class="anci_column_subject">Baggage</span>
                          <span class="anci_column_name">{{sector.baggageCheckIn}}</span>
                        </div>
                        <div style=" width: 10%">
                          <!--airarabia-->
                          @if (bookingInfo.providerCode == 'G9' || bookingInfo.providerCode == '3L' || bookingInfo.providerCode == '9P') {
<div>
                            @if (sector.baggagebtn) {
<button class="anci_column_edit" (click)="baggageopen(i,z)"><i class="fas fa-edit"></i></button>
}
                          </div>
}
                          <!--flydubai-->
                          @if (bookingInfo.providerCode == 'FZ') {
<div>
                            @if (sector.baggagebtn) {
<button class="anci_column_edit" (click)="fzBaggageClick(i,z,poperrornot)"><i class="fas fa-edit"></i></button>
}
                          </div>
}



                          <!--popup of baggage-->
                          <div id="baggagepopup{{i}}{{z}}" class="numofseatmodel">


                            <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                              <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                                <div class="modal-content" style="width:100% !important">
                                  <div class="modal-header">
                                    <div class="seat_model_header">
                                      <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Baggage Selection</span>
                                      <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="baggageclose(i,z)" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="modal-body" style="padding: 0px !important;">
                                    <div style="width:100%;display:flex;">
                                      <div style="width:30%;padding:6px;">
                                        <div class="mt-2 seat_info">
                                          <span class="seat_info_header">
                                            Baggage Information
                                          </span>
                                          <span class="seat_info_header_sector">
                                            {{sector.fromAirport}} To {{sector.toAirport}}
                                          </span>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <span class="seat_info_one_head ">
                                                Name:
                                              </span>
                                            </div>
                                            <div class="col-md-8" style="overflow:hidden;display:flex">
                                              <span class="seat_info_one">
                                                {{obj.firstName}}
                                              </span>
                                            </div>

                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <span class="seat_info_one_head ">
                                                Baggage:
                                              </span>
                                            </div>
                                            <div class="col-md-8" style="overflow:hidden;display:flex">
                                              <span class="seat_info_one">
                                                {{sector.baggageCheckIn}}
                                              </span>
                                            </div>

                                          </div>
                                          <div class="row">
                                            <div class="col-md-8">
                                              <span class="seat_info_one_head ">
                                                Baggage Charges:
                                              </span>
                                            </div>
                                            <div class="col-md-4">
                                              @if (bookingInfo.providerCode == 'G9' || bookingInfo.providerCode == '3L' || bookingInfo.providerCode == '9P') {
<span class="seat_info_one">
                                                {{currency}} {{(sector.baggageFee * currencyRate)| number: '1.1-2'}}
                                              </span>
}
                                              @if (bookingInfo.supplierCode == 'FZ') {
<span class="seat_info_one">
                                                {{currency}} {{(sector.baggageFee)| number: '1.1-2'}}
                                              </span>
}
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                      <div style="width:70%;padding:6px;">
                                        <div class="meal_deatils_main">
                                          <div class="baggage_container">
                                            <div style="display:flex;flex-direction:column;">
                                              <span style="color:var(--first-color-second);font-weight:bold;">Checked Baggage</span>
                                              <span style="color:black;margin-bottom:4px;">It maybe  cheaper to book sufficient baggage allowance now than paying excess fee at the airport.</span>

                                              <span style="color: black; font-weight: bold; margin-bottom: 8px;">Pick your preferred weight</span>


                                            </div>
                                            <div class="cards_of_bagage">
                                              @if (bookingInfo.providerCode == 'G9' || bookingInfo.providerCode == '3L' || bookingInfo.providerCode == '9P') {
<div class="row m-0 ">
                                                @for (baggagesector of sector.baggaesBysector; track baggagesector; let b = $index) {
<div class="col-sm-4  baggage_container" style="margin-bottom: 4px;">
                                                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                                    <span style="color:var(--first-color-second);font-size:50px">
                                                      <i class="fas fa-suitcase"></i>
                                                    </span>
                                                    <span style="color: black; font-weight: bold; font-size: 14px; margin-bottom: 6px;">
                                                      {{baggagesector.baggageCode}}
                                                    </span>
                                                    <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.baggageCharge * currencyRate)| number: '1.1-2'}}</span>
                                                    <button class="meal_button_add" id="baggageselectbtn{{i}}{{z}}{{b}}" (click)="baggageselect(i,z,b)"><span id="baggageselectid{{i}}{{z}}{{b}}">Select</span></button>
                                                  </div>
                                                </div>
}
                                              </div>
}
                                              @if (bookingInfo.providerCode == 'FZ') {
<div class="rrr">
                                                @for (baggagesector of fzBaggageArray; track baggagesector; let b = $index) {
<div class="ttt">
                                                  <!--<div class="sss" *ngFor="let baggagesector of baggagesectors;let a=index;">-->
                                                    <div class="vvv">
                                                      <span style="color:var(--first-color-second);font-size:50px">
                                                        <i class="fas fa-suitcase"></i>
                                                      </span>
                                                      <span style="color: black; font-weight: bold; font-size: 14px; margin-bottom: 6px;padding-left:14px;">
                                                        {{baggagesector.description}}
                                                      </span>
                                                      <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.amount * currencyRate) | number: '1.1-2'}}</span>
                                                      <button class="meal_button_add" id="baggageselectbtn{{i}}{{z}}{{b}}" (click)="fzBaggageSelect(i,z,b)"><span id="baggageselectid{{i}}{{z}}{{b}}{{a}}">Select</span></button>
                                                    </div>
                                                  <!--</div>-->
                                                </div>
}

                                              </div>
}
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <!--end meal popup-->
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="çol-md-4">
                      <span class="first-required" id="mealselectmessage{{i}}{{z}}"></span>
                    </div>
                    <div class="çol-md-4">
                      <span class="first-required" id="seatselectmessage{{i}}{{z}}"></span>
                    </div>
                    <div class="çol-md-4">
                      <span class="first-required" id="baggageselectmessage{{i}}{{z}}"></span>
                    </div>
                  </div>
                </div>
}

              </div>
}

            </div>
          </div>
}
          <div style=" text-align: end; margin-right: 14px;">
            <button class="anxiBtn" (click)="SubmitAnxiToBooking()">Submit</button>
          </div>
        </form>


        <!--//Remove Anxi rrrm-anxi-->
        <form class="noti col-sm-9 form-line-active rm-anxi rrrm-anxi">
          <div class="anxi_title cross">Remove Anxillaries <span style="color:#008A00;font-size:11pt" (click)="removeAnxiClose()"> &#x274c; </span></div>
          @for (obj of bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
<div class="forms_container_main infant_type">
            <div class="main_form">
              <p class="">{{obj.firstName +" " +obj.lastName}}</p>

              @if ((airarbiaWithBaggage || fzAnxii) &&  obj.passengerType != 3) {
<div class="Anci_mainClass">
                <div style="font-weight: bold; font-size: 18px; color: var(--first-color-second); padding: 5px; justify-content: center; display: flex; ">
                  Extras
                </div>
                @for (sector of obj.sectorInformationProperties; track sector; let z = $index) {
<div class="anci_section_main">
                  <div class="row" style=" margin-left: 21px;">
                    <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
                  </div>
                  <div class="anci_section_border">
                    <div class="anci_Section_columns">
                      <div class="anci_columns_head">
                        <div class="anci_columns_subhead">
                          <span class="anci_column_subject">Meal</span>
                          <span class="anci_column_name">{{sector.meal}}</span>
                          <input class="inp-meal" type="checkbox" [(ngModel)]="sector.mealRemReq" id="Meal{{z}}" name="Meal{{z}}" />
                        </div>

                      </div>
                    </div>

                    <!--seat map of anci selectio -->

                    <div class="anci_Section_columns" style="margin-left:0.4%">
                      <div class="anci_columns_head">
                        <div class="anci_columns_subhead">
                          <span class="anci_column_subject">Baggage</span>
                          <span class="anci_column_name">{{sector.baggageCode}}</span>
                          @if (sector.baggagebtn) {
<input class="inp-meal" type="checkbox" [(ngModel)]="sector.bagRemReq" id="Baggage{{z}}" name="Baggage{{z}}" />
}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="çol-md-4">
                      <span class="first-required" id="mealselectmessage{{i}}{{z}}"></span>
                    </div>
                    <div class="çol-md-4">
                      <span class="first-required" id="seatselectmessage{{i}}{{z}}"></span>
                    </div>
                    <div class="çol-md-4">
                      <span class="first-required" id="baggageselectmessage{{i}}{{z}}"></span>
                    </div>
                  </div>
                </div>
}

              </div>
}

            </div>
          </div>
}
          <div style="display:flex;width:100%;">
            <div style="width:50%;text-align:left;display:flex">
              <span style="margin-left:4px;color:red;font-weight:bold;font-size:13px" id="removeanxiid"></span>
            </div>
            <div style="width: 50%; text-align: right; display: flex;justify-content:right">
              <button class="anxiBtn" (click)="RemoveAnxiFromPNR()">Submit</button>
            </div>
          </div>
         
        </form>

        <!--//Add seat  -->

        <form class="noti seats-main col-sm-9 form-line-active seat-anxi hid-seats">
          <div class="anxi_title cross">Add Seats <span style="color:#008A00;font-size:11pt" (click)="seatsSectionClose()"> &#x274c; </span> </div>
          @for (obj of bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
<div class="forms_container_main infant_type">
            <div class="main_form">
              <p class="">{{obj.firstName +" " +obj.lastName}}</p>

              <!--*ngIf=" obj.providerCode == 'FZ'"-->
              @if ((airarbiaWithBaggage || fzAnxii) &&  obj.passengerType != 3) {
<div class="Anci_mainClass">
                @for (sector of obj.sectorInformationProperties; track sector; let z = $index) {
<div class="anci_section_main">
                  <div class="row">
                    <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
                  </div>
                  <div class="anci_Section_columns" style="margin-left:0.4%">
                    <div class="anci_columns_head">
                      <div class="anci_columns_subhead">
                        <span class="anci_column_subject">Seat</span>
                        <span class="anci_column_name">{{sector.seatNumber}}</span>
                      </div>
                      <div style=" width: 10%">
                        @if (sector.seatNumber == null || sector.seatNumber == '' || sector.seatNumber == undefined) {
<button class="anci_column_edit" (click)="seatMapopen(i,z)" id="seatselectid{{i}}{{z}}"><i class="fas fa-edit"></i></button>
}
                        <div id="newmodelofseat{{i}}{{z}}" class="numofseatmodel">
                          <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                            <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                              <div class="modal-content" style="width:100% !important">
                                <div class="modal-header">
                                  <div class="seat_model_header">
                                    <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                    <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="seatMapclose(i,z)" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="modal-body" style="padding: 0px !important;">
                                  <div class="seat_model_body_one">
                                    <div class="seat_model_body_two">
                                      <span class="seat_info_header">
                                        Seatmap Legend
                                      </span>
                                      <div class="row mb-2">
                                        <div class="col-md-3">
                                          <button class="square-skew " disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>

                                        <div class="col-md-9">
                                          <span>Seat Available</span>
                                        </div>
                                 
                                      </div>
                                      
                                      
                                      <div class="row mb-2">
                                        <div class="col-md-3">
                                          <button class="square-skew_not not_avail_Seat" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Unavailable</span>
                                        </div>
                                        /d
                                      </div>
                                  
                                      
                                      <div class="row mb-2">
                                        <div class="col-md-3">

                                          <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Selected</span>
                                        </div>

                                      

                                      </div>
                                     
                                      
                                      <div class="row ">
                                        <div class="col-md-3">


                                          <button class="square-skew_not" style="background-color:orangered" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>



                                        </div>


                                        <div class="col-md-9">
                                          <span>Seat Selected By Another Passenger</span>
                                        </div>

                                      </div>


                                    </div>
                                    <div class="mt-2 seat_info">
                                      <span class="seat_info_header">
                                        Seat Information
                                      </span>
                                      <span class="seat_info_header_sector">
                                        {{sector.fromAirport}} To {{sector.toAirport}}
                                      </span>
                                      <div class="row">
                                        <div class="col-md-4">
                                          <span class="seat_info_one_head ">
                                            Name:
                                          </span>
                                        </div>
                                        <div class="col-md-8" style="overflow:hidden;display:flex">
                                          <span class="seat_info_one">
                                            {{obj.firstName}}
                                          </span>
                                        </div>

                                      </div>
                                      <div class="row">
                                        <div class="col-md-4">
                                          <span class="seat_info_one_head ">
                                            Seat No:
                                          </span>
                                        </div>
                                        <div class="col-md-8">
                                          <span class="seat_info_one">
                                            {{sector.seatNumber}}
                                          </span>
                                        </div>

                                      </div>
                                      <div class="row">
                                        <div class="col-md-7">
                                          <span class="seat_info_one_head ">
                                            Seat Charges:
                                          </span>
                                        </div>
                                        <div class="col-md-5">
                                          <span class="seat_info_one">
                                            <!--* currencyRate-->
                                            {{currency}} {{((sector.seatFee * currencyRate )| number: '1.1-2')}}
                                          </span>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                  <div class="seat_mdl_bdy_airone">
                                    <div class="seat_mdl_bdy_airtwo">
                                      <div>
                                        <img class="seat_wing_one" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                      </div>

                                      <div class="aircraft">
                                        <div class="aircraft-head">
                                          <!-- <div class="aircraft-head_inner"> -->
                                          <img style="width: 180px; padding-top: 32px;"
                                               src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                        <!-- </div> -->
                                      </div>
                                      <div class="aircraft-body-exit-top">
                                        <div class="aircraft-body-exit-left-top">
                                        </div>
                                        <div class="aircraft-body-exit-top-center">
                                        </div>
                                        <div class="aircraft-body-exit-right-top">
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit">
                                        <div class="aircraft-body-exit-left">
                                          <div class="aircraft-inner-rowclass">
                                            <span>A</span>
                                            <span>B</span>
                                            <span>C</span>
                                          </div>
                                        </div>
                                        <div class="aircraft-body-exit-right">
                                          <div class="aircraft-inner-rowclass">
                                            <span>D</span>
                                            <span>E</span>
                                            <span>F</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="aircraft-body-exit-top">
                                        <div class="aircraft-body-exit-left-top">
                                        </div>
                                        <div class="aircraft-body-exit-top-center">
                                        </div>
                                        <div class="aircraft-body-exit-right-top">
                                        </div>
                                      </div>
                                      <div class="aircraft-body-rowClass">
                                        <div class="aircraft-row-innner-body">
                                          <div class="aircraft_inner_divone">
                                            @for (rows of sector.seatListBysector; track rows; let k = $index) {
                                              <div class="aircraft_inner_divtwo">
                                                @for (seatobj of rows.seats; track seatobj; let q = $index) {
                                                  <div>
                                                    @if (seatobj.seatStatus == 'VAC' ) {
                                                      <button class="square-skew hover-text" (click)="seatselectedsector(i,z,k,q)" id="link3button{{i}}{{z}}{{k}}{{q}}">
                                                        <!--* currencyRate-->
                                                        <span class="tooltip-text" id="top{{k}}{{q}}">Seat Charge:{{currency}} {{(seatobj.seatCharge * currencyRate )| number: '1.1-2'}}</span>
                                                    <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />

                                                  </button>
}

                                                  @if (seatobj.seatStatus == 'RES' || seatobj.seatStatus == 'INA' ) {
<button class="square-skew_not not_avail_Seat" disabled id="link3{{k}}{{q}}">
                                                    <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                    <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                                  </button>
}
                                                  @if (seatobj.seatStatus == 'RSP' ) {
<button class="square-skew_not" style="background-color:orangered;cursor:not-allowed" disabled id="link3{{k}}{{q}}">
                                                    <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                    <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                                  </button>
}
                                                  @if ((q==2)) {
<button id="link3{{k}}{{q}}" class="aircraft_inner_res">
                                                    {{rows.rowNumber}}
                                                  </button>
}

                                                </div>
}


                                              </div>
}



                                            </div>

                                          </div>
                                        </div>

                                        <!-- <div class="aircraft-bottom-wing">
                                  <div class="exists">
                                    <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                    <div><img src="https://i.ibb.co/ftwgLCL/exist.png"></div>
                                  </div>
                                </div> -->
                                      </div>
                                      <div>
                                        <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
}


              </div>
}
            </div>

          </div>
}
          <div style="display:flex;width:100%;">
            <div style="width:50%;text-align:left;display:flex">
              <span style="margin-left:4px;color:red;font-weight:bold;font-size:13px" id="seataddid"></span>
            </div>
            <div style="width: 50%; text-align: right; display: flex;justify-content:right">
              <button class="btn-seat" (click)="submitSeatsForBookingMod()">Submit</button>
            </div>
          </div>
          
        </form>

        <!--//remove Seat hid-rem-seats-->

        <form class="noti seats-main col-sm-9 form-line-active seat-rem-anxi hid-rem-seats">
          <div class="anxi_title cross">Remove Seats <span style="color:#008A00;font-size:11pt" (click)="seatsRemSectionClose()"> &#x274c; </span></div>
          @for (obj of bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
<div class="forms_container_main infant_type">
            <div class="main_form">
              <p class="">{{obj.firstName +" " +obj.lastName}}</p>

              <!--*ngIf=" obj.providerCode == 'FZ'"-->
              @if ((airarbiaWithBaggage || fzAnxii) &&  obj.passengerType != 3) {
<div class="Anci_mainClass">
                @for (sector of obj.sectorInformationProperties; track sector; let z = $index) {
<div class="anci_section_main">
                  <div class="row">
                    <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
                  </div>
                  <div class="anci_Section_columns" style="margin-left:0.4%">
                    <div class="anci_columns_head">
                      <div class="anci_columns_subhead">
                        <span class="anci_column_subject">Seat</span>
                        <span class="anci_column_name">{{sector.seatNumber}}</span>
                        <input class="inp-meal" type="checkbox" [(ngModel)]="sector.seatRemReq" id="Seat{{z}}" name="Seat{{z}}" />
                      </div>

                    </div>
                  </div>
                </div>
}


              </div>
}
            </div>

          </div>
}
          <div style="display:flex;width:100%;">
            <div style="width:50%;text-align:left;display:flex">
              <span style="margin-left:4px;color:red;font-weight:bold;font-size:13px" id="removeseatid"></span>
            </div>
            <div style="width: 50%; text-align: right; display: flex;justify-content:right">
              <button class="btn-seat" (click)="submitRemoveSeatsMod()">Submit</button>
            </div>
          </div>
          
        </form>



      </div>
      <div class="pricesummary">

        <div class="right_side right_side_container">

          <div class="noti col-sm-12 price_summary">

            <h4 class="PassegerHeading" style="margin-bottom:20px">
              Price Summary
            </h4>
            @for (price of priceCardDetails; track price) {
<div>
              <div class="d-flex justify-content-between align-items-center price_summary_children_type"><label>{{price.passengerType}} @if (price.passengerCount > 1) {
<span>x {{price.passengerCount}}</span>
}</label></div>

              <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.indivisualBasePrice}}</span></div>-->

              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.agencyBasePrice}}</span></div>

              <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.indivisualTaxes}}</span></div>-->

              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.agencyTaxes}}</span></div>
              <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.serviceFee}}</span></div>-->

              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.agencyServiceFee}}</span></div>
              <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.discount}}</span></div>-->
              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.agencyDiscount}}</span></div>
              <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.indivisualTotalPrice}}</span></div>-->

              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Seat Fee</label><span>{{price.seatFee}}</span></div>
              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Meal Fee</label><span>{{price.mealFee}}</span></div>
              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Baggage Fee</label><span>{{price.baggageFee}}</span></div>
              <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.agencyTotalPrice}}</span></div>

              <hr style="margin-top:20px" />
            </div>
}
            <div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label">Total Base Price</label><span class="price_total_tag">{{totalBasePriceConv}}</span></div>

            <div class="d-flex justify-content-between align-items-center price_summary_children">

              <label class="price_total_label">Total Taxes</label><span class="price_total_tag">{{totalTaxesConv}}</span>

            </div>
            <div class="d-flex justify-content-between align-items-center price_summary_children">

              <label class="price_total_label">Total Discount</label><span class="price_total_tag">{{totalDiscountConv}}</span>

            </div>
            <div class="d-flex justify-content-between align-items-center price_summary_children">

              <label class="price_total_label">Total ServiceFee</label><span class="price_total_tag">{{totalServiceFeeConv}}</span>

            </div>
            <div class="d-flex justify-content-between align-items-center price_summary_children">

              <label class="price_total_label">Total ANCI Fee</label><span class="price_total_tag">{{totalANCIConv}}</span>

            </div>
            <div class="d-flex justify-content-between align-items-center price_summary_children">

              <label class="price_total_label" style="font-weight: 800;font-size:12.5px">Trip Total</label><span class="price_total_tag" style="font-weight:800;font-size:12.5px">{{totalPriceConv}}</span>

            </div>

          </div>
        </div>

      </div>
    </div>


  </div>
  <ng-template #delete let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{ModifyData.modifyType}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h5 style=" color: #FD6F01; padding:2px;">For This Modifications</h5>
      <table style="width:100%">
        <tr style="text-align:center;">
          <td style="width:50%;">Balance Payable</td>
          <td>{{ModifyData.reservationBalance}}</td>
        </tr>
        <tr style="text-align:center;">
          <td style="width:50%;">Change Cost</td>
          <td>{{ModifyData.changeCost}}</td>
        </tr>
      </table>

    </div>
    <div class="modal-footer">
      <div> <label class="footertext">Do you Want to Continue?</label></div>
      <div>
        <button type="button" class="noButton" (click)="modal.dismiss()">No</button>
        <button type="button" class="yesButton" (click)="CommitModifyRequest(ModifyData.modifyType)">Yes</button>

      </div>
    </div>

  </ng-template>
